exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* OVO ODREĐUJE POČETAK CONTAINERA I TEKSTA ISPOD NAVBARA */\n\n@media (max-width: 500px) {\n  .app-container[_ngcontent-c0][_ngcontent-c0] {\n      padding-top: 30px;\n  }\n   }\n   @media (min-width: 501px)  {\n    .app-container[_ngcontent-c0][_ngcontent-c0] {\n        padding-top: 30px;\n    }\n     }\n     @media (min-width: 768px)  {\n         .app-container[_ngcontent-c0][_ngcontent-c0] {\n    padding-top: 40px;\n}\n }\n @media (min-width: 992px)  {\n    .app-container[_ngcontent-c0][_ngcontent-c0] {\n        padding-top: 33px;\n    }\n     }\n     @media (min-width: 1200px)  {\n        .app-container[_ngcontent-c0][_ngcontent-c0] {\n            padding-top: 35px;\n        }\n         }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/milic/self-legal/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main